// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__kwDyd","IconeMenu":"Menu_IconeMenu__33QWS","IconeMenuSticky":"Menu_IconeMenuSticky__C7kBX"};